import { jsx as _jsx } from "react/jsx-runtime";
import { addIntersectionObserver, removeIntersectionObserver } from "@cinch-labs/shared-util";
import cx from "classnames";
import { useEffect, useState } from "react";
import styles from "./lazy-image.module.css";
const LazyImage = ({ className ="" , onError , ...props })=>{
    let imgRef;
    const [isLoaded, updateLoadedState] = useState(false);
    const [isVisible, setVisibility] = useState(false);
    const handleIntersection = (isIntersecting)=>{
        if (isIntersecting && !!imgRef) {
            removeIntersectionObserver(imgRef);
            setVisibility(true);
        }
    };
    const addObserver = ()=>{
        if (imgRef) {
            addIntersectionObserver(handleIntersection, imgRef);
        }
    };
    useEffect(()=>{
        if (!imgRef) {
            return;
        }
        addObserver();
        return ()=>{
            if (imgRef) {
                removeIntersectionObserver(imgRef);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.src
    ]);
    const handleRef = (ref)=>{
        if (!ref && imgRef) {
            removeIntersectionObserver(imgRef);
        }
        imgRef = ref;
        addObserver();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visibleProp = {};
    if (isVisible) {
        visibleProp.src = props.src;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.lazyWrapper,
        children: /*#__PURE__*/ _jsx("img", {
            className: cx(styles.lazy, className, {
                [styles.lazyLoaded]: isLoaded
            }),
            ref: handleRef,
            alt: props.alt || "",
            onError: onError,
            onLoad: ()=>updateLoadedState(true),
            ...visibleProp
        })
    });
};
export default LazyImage;
